import { formatDateIso } from '../../dateTime';

import { fetchChannelProgramsQuery } from './fetchChannelProgramsQuery';
import { searchLiveProgram } from './utils';

export type FetchChannelLiveProgramArgs = {
  channelId: number;
  timestamp: number;
};

export async function fetchChannelLiveProgram({ channelId, timestamp }: FetchChannelLiveProgramArgs) {
  const programs = await fetchChannelProgramsQuery({ channelId, day: formatDateIso(new Date(timestamp)) });

  if (!programs) {
    return Promise.resolve();
  }

  return searchLiveProgram(programs);
}
